import { createContext } from "react"

const CloseWindowContext = createContext(() => { })

export default CloseWindowContext